import { FC, useEffect, useRef } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Dialog,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Pagination,
  Paper,
  Typography,
} from "@mui/material"
import { UButton } from "@/components/index"
import { ArrowDropDown, ExpandMore } from "@mui/icons-material"
import UTableSearch from "../PatientList/components/UTable/UTableSearch"
import PersonIcon from "@mui/icons-material/Person"

import { useAppDispatch, useAppSelector, useDeepEffect } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { get3ShapeCaseList } from "@/core/app/slices/patients/patientThunkApi"
import useLocalStorageListener from "@/modules/Settings/Integrations/localStorageHooks"
import { setData } from "@/core/app/slices/patients/patientSlice"
import { usePageHeight } from "@/UDTreat/top/GetViewWidth"
import { debounce } from "lodash"
const ScannerPatients: FC = ({
  showScannerPatients,
  setShowScannerPatients,
  choosePatient,
}) => {
  const dispatch = useAppDispatch()
  const { caseListFor3Shape, scannerSelect, scannerCaseListCount } = useAppSelector(
    (state: RootState) => state.patientService,
  )
  console.log("980caseListFor3Shape", caseListFor3Shape)
  const [filterList, setFilterList] = useState<any[]>([])
  // search text
  const [searchText, setSearchText] = useState<string>("")
  useEffect(() => {
    if (!showScannerPatients) {
      setSearchText("")
    }
  }, [showScannerPatients])
  // table page
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const formatUTC = (dateStr) => {
    if (!dateStr) {
      return ""
    }
    const date = new Date(dateStr)

    // 提取UTC时间分量
    const month = date.getUTCMonth() + 1 // 0-11 → 1-12
    const day = date.getUTCDate()
    const year = date.getUTCFullYear()
    let hours = date.getUTCHours()
    const minutes = String(date.getUTCMinutes()).padStart(2, "0")

    // 转换为12小时制AM/PM
    const period = hours >= 12 ? "PM" : "AM"
    hours = hours % 12 || 12 // 0点转为12 AM

    return `${month}/${day}/${year}, ${hours}:${minutes} ${period}`
  }

  const [scannerSelectData, setScannerSelectData] = useState([])
  // locastorage key  3shapeData， meditData, alliesData
  const shapeLocal = useLocalStorageListener("3shapeData", null)
  const meditDataLocal = useLocalStorageListener("meditData", null)
  const alliesDataLocal = useLocalStorageListener("alliesData", null)
  const scannerSelectDataReady = useRef(false)

  useDeepEffect(() => {
    if (scannerSelect === "" || !scannerSelectDataReady.current) return
    dispatch(get3ShapeCaseList({ page: 0, type: scannerSelect, name: searchText }))
    setPage(0)
  }, [searchText])

  useDeepEffect(() => {
    const tmp = []
    if (shapeLocal) {
      const shapeScanner = JSON.parse(
        localStorage.getItem("3shapeData") || "{}",
      )
      tmp.push({
        name: "3Shape",
        key: "3Shape",
        isPrimary: shapeScanner.isPrimary,
      })
    }
    if (meditDataLocal) {
      const meditScanner = JSON.parse(localStorage.getItem("meditData") || "{}")
      tmp.push({
        name: "Medit",
        key: "Medit",
        isPrimary: meditScanner.isPrimary,
      })
    }
    if (alliesDataLocal) {
      const allieScanner = JSON.parse(
        localStorage.getItem("alliesData") || "{}",
      )
      tmp.push({
        name: "Alliedstar",
        key: "Alliedstar",
        isPrimary: allieScanner.isPrimary,
      })
    }
    setScannerSelectData(tmp)
    
  }, [shapeLocal, meditDataLocal, alliesDataLocal])
  useDeepEffect(() => {
    if (!scannerSelectData.length || !scannerSelectDataReady.current) return
    // get scanner patientList
    setSearchText("")
    dispatch(get3ShapeCaseList({ page: 0, type: scannerSelect, name: searchText }))
    setPage(0)
  }, [scannerSelect, scannerSelectDataReady.current])
  useDeepEffect(() => {
    if(scannerSelect === "" || !scannerSelectDataReady.current) return
    dispatch(get3ShapeCaseList({ page: page, type: scannerSelect, name: searchText }))
  }, [page])
  useEffect(() => {
    if (caseListFor3Shape) {
      setFilterList([...caseListFor3Shape])
    }
  }, [caseListFor3Shape])
  // const currentData = filterList.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage,
  // )
  // set primary select
  useDeepEffect(() => {
    if (scannerSelectData.length) {
      let primaryScanner = ""
      scannerSelectData.map((i) => {
        if (i.isPrimary) {
          primaryScanner = i.key
        }
      })
      dispatch(setData({ scannerSelect: primaryScanner }))
      scannerSelectDataReady.current = true
    }
  }, [scannerSelectData])

  const windowHeight = usePageHeight()
  return (
    <Dialog
      sx={{
        '& .MuiDialog-container': {
          height: "100%", 
        },
        "& .MuiPaper-root": {
          borderRadius: "16px",
        },
         "& .MuiDialog-paper": {
          maxHeight: "92%",
          aspectRatio: 0.652,
          overflow: "hidden",
        },
      }}
      open={showScannerPatients}
    >
      <Box
        sx={{
          width: 564,
          height: 864,
          minHeight: 864,
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          transform: `scale(${windowHeight / 945 > 1 ? 1: windowHeight / 945 })`,
          transformOrigin: 'top left',
        }}
      >
        <Box sx={{ height: "96px", width: "100%" }}>
          <Select
            value={scannerSelect}
            sx={{
              "& .MuiInputBase-root": {
                height: "32px",
              },
              "& .MuiSelect-select": {
                padding: "0 32px 0 0",
                fontSize: "24px",
                color: "rgba(0,0,0,0.87)",
                minHeight: "unset !important",
              },
              "& .MuiSvgIcon-root": {
                right: "0",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                display: "none",
                border: "none", // 去除默认边框
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none", // 去除悬停状态边框
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none", // 去除聚焦状态边框
              },     
            }}
            IconComponent={ExpandMore} // 替换为 Material-UI 内置图标
            // MenuProps={{
            //   PaperProps: {
            //     sx: {
            //       "& .MuiMenuItem-root": { padding: "8px 16px" },
            //     },
            //   },
            // }}
            onChange={(eve) => {
              dispatch(setData({ scannerSelect: eve.target.value }))
            }}
          >
            {scannerSelectData.map((i) => {
              return (
                <MenuItem key={i.key} value={i.name} >
                  {i.name}
                </MenuItem>
              )
            })}
          </Select>
          <Box sx={{ width: "100%", margin: "16px 0" }}>
            <UTableSearch
              onSearch={
                debounce((value) => {
                  setSearchText(value)
                }, 1000)
              }
              searchText={searchText}
            />
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden"}}>
          <TableContainer
            component={Paper}
            sx={{
              border: "0",
              borderRadius: "4px !important",
              boxShadow: "none",
              background: "rgba(0,0,0,0.12)",
              borderColor: "rgba(0,0,0,0.23)",
              marginTop: "3px",
              padding: "0 10px",
              "& .MuiTable-root": {
                borderSpacing: "0 7px", // 纵向间隙高度
                borderCollapse: "separate", // 必须设置
              },
            }}
          >
            <Table aria-label="scanner patients" size="small">
              <TableBody>
                {/* .slice(page * rowsPerPage, (page + 1) * rowsPerPage) */}
                {filterList &&
                  filterList.map((row) => (
                    <TableRow
                      sx={{
                        background: "#fff",
                        height: "48px",
                        padding: "17px",
                        borderRadius: "4px",
                        overflow: "hidden",
                        cursor: "pointer",
                        "&:first-of-type": {
                          borderTopLeftRadius: "4px",
                          borderTopRightRadius: "4px",
                        },
                        "&:last-of-type": {
                          borderBottomLeftRadius: "4px",
                          borderBottomRightRadius: "4px",
                        },
                        "&:hover": {
                          backgroundColor: "#f5f5f5", // 自定义颜色‌:ml-citation{ref="3,4" data="citationList"}
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)", // 添加投影效果‌:ml-citation{ref="3" data="citationList"}
                        },
                      }}
                      key={row.Info.CaseId}
                      onClick={() => {
                        setShowScannerPatients(false)
                        choosePatient(row)
                      }}
                    >
                      <TableCell
                        sx={{
                          border: "none",
                          "&:first-of-type": {
                            borderLeft: "1px solid #e0e0e0",
                            borderTopLeftRadius: "inherit", // 继承行级圆角
                            borderBottomLeftRadius: "inherit",
                          },
                          "&:last-of-type": {
                            borderRight: "1px solid #e0e0e0",
                            borderTopRightRadius: "inherit",
                            borderBottomRightRadius: "inherit",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "16px",
                          }}
                        >
                          <PersonIcon
                            sx={{
                              fontSize: "40px",
                              color: "#9E9E9E",
                              marginRight: "16px",
                            }}
                          />
                          <span
                            style={{
                              width: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.Info.PatientName}
                          </span>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "none",
                          color: "rgba(0,0,0,0.6)",
                          textAlign: "right",
                          "&:first-of-type": {
                            borderLeft: "1px solid #e0e0e0",
                            borderTopLeftRadius: "inherit", // 继承行级圆角
                            borderBottomLeftRadius: "inherit",
                          },
                          "&:last-of-type": {
                            borderRight: "1px solid #e0e0e0",
                            borderTopRightRadius: "inherit",
                            borderBottomRightRadius: "inherit",
                          },
                        }}
                      >
                        {formatUTC(row.Info.CreateTime)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
            paddingRight: 2,
          }}
        >
          <Pagination
            count={Math.ceil(scannerCaseListCount / rowsPerPage)}
            page={page + 1}
            onChange={(e, newPage) => setPage(newPage - 1)}
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 2.5,
              padding: "0 0 0 55px",
              "& .MuiPagination-ul": {
                flexWrap: "nowrap",
              },
              maxWidth: "348px",
            }}
            showFirstButton
            showLastButton
            siblingCount={0}
            boundaryCount={1}
          />
          <Typography
            variant="body2"
            sx={{
              mt: 2.5,
              whiteSpace: "nowrap",
              fontSize: "14px",
              color: "rgba(0,0,0,0.6)",
            }}
          >
            {page * rowsPerPage + 1}-
            {page * rowsPerPage + rowsPerPage > scannerCaseListCount
              ? scannerCaseListCount
              : page * rowsPerPage + rowsPerPage}{" "}
            of {scannerCaseListCount}
          </Typography>
        </Box>
        <Box
          sx={{
            marginTop: "16px",
            height: "36px",
            width: "100%",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <UButton
            variant="contained"
            btnText={"Close"}
            sxProp={{
              width: "78px",
              height: "36px",
              padding: "6px 16px",
              background: "#e0e0e0",
              color: "rgba(0,0,0,0.87)",
            }}
            onClickHandler={() => {
              setShowScannerPatients(false)
              dispatch(setData({ caseListFor3Shape: [] }))
              scannerSelectDataReady.current = false
            }}
          ></UButton>
        </Box>
      </Box>
    </Dialog>
  )
}
export default ScannerPatients
